import Component from './component';

Component.defaultProps = {
    layoutContainerProps: null,
    descriptionProps: null,
    buttonProps: null,
};
export default Component;
